import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import listPageReducer from './data/reducer';
import listPageSaga from './data/sagas';
import routes from './routes';

const reducer = combineReducers({
  listPage: listPageReducer,
});

const saga = function* () {
  yield all([listPageSaga()]);
};

export { reducer, saga, routes };
